var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UploadStatusList',{attrs:{"show":_vm.showDialog,"statuses":_vm.uploadStatuses}})}
var staticRenderFns = []

export { render, staticRenderFns }